import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { enums, routes } from '../../../constants'
import { actions } from '../chavesCertificado.actions'
import { ChavesCertificadoForm } from './ChavesCertificadoForm'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
    const messages = state.crudChavesCertificadoState.messages
    const record = state.crudChavesCertificadoState.currentRecord

    return {
        record,
        messages,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
        sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
        applyFilter: (filterParams) => {
            dispatch(actions.setType(null))
            dispatch(actions.applyFilter(filterParams))
        },
        setField: (field, value) => dispatch(actions.setField(field, value)),
        changeHandler: (event) => {
            const target = event.target
            const field = target.name
            let valor = target.value
            dispatch(actions.removeErrors([{ field }]))
            dispatch(actions.setField(field, valor))
        },
        onClickBotaoDinamico: (listId, oidBotao) => dispatch(actions.executarFuncaoDinamica(listId, oidBotao)),
        saveHandler: (event) => dispatch(actions.save()),
        removeHandler: (event) => dispatch(actions.remove()),
        newHandler: (event) => dispatch(actions.makeNew()),
        loadById: (oid) => dispatch(actions.loadById(oid)),
        loadFavorito: (menu) => dispatch(actions.loadFavorito(menu)),
        removeFavorito: (menu) => dispatch(actions.removeFavorito(menu)),
        adicionarFavorito: (menu) => dispatch(actions.adicionarFavorito(menu)),
        getBotoesDinamicos: (idTela) => {
            let tipoTela = Number(enums.TipoTela.FORMULARIO)
            dispatch(actions.getBotoesDinamicos(idTela, tipoTela))
        },
        configurarContaAilos: (unidade) => dispatch(actions.configurarContaAilos(unidade)),
        showWarningMessage: (message) => dispatch(actions.showWarningMessage(message)),
    }
}

class ChavesCertificadoFormPageContainer extends React.Component {
    constructor(props) {
        super(props)
        this.showPesquisarButton = false
        this.showCSVButton = false
        this.showColumnButton = false
        this.hideBtnImportacao = true
        this.state = {
            dadosFavorito: null,
            favorito: 0,
            unidade: this.props.unidade,
        }
        actions.afterNew = () => {
            this.props.history.push(`${routes.PATH_CERTIFICADO}`)
        }
        actions.afterLoadFavorito = (data) => {
            if (data && data.oid) {
                this.setState({ favorito: 1 })
                this.setState({ dadosFavorito: data })
            } else {
                this.setState({ favorito: 0 })
                this.setState({ dadosFavorito: null })
            }
        }
    }

    componentDidMount() {
        logarAcesso().then()
        this.props.loadFavorito(this.props.history.location.pathname)
    }

    loadFavorito() {
        listPageUtils.loadFavorito(this, actions)
    }

    changeFavorito() {
        listPageUtils.changeFavorito(this, actions)
    }


    buildHeader = () => {
        return (
            <div>
                <DefaultToolBar listPageContainer={this} title={'Extrair chaves certificado'} />
            </div>
        )
    }

    render() {
        const content = (
            <ChavesCertificadoForm />
        )

        return <Page content={content} header={this.buildHeader()} />
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChavesCertificadoFormPageContainer)
